/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const updateInterview = /* GraphQL */ `
  mutation UpdateInterview(
    $input: UpdateInterviewInput!
    $condition: ModelInterviewConditionInput
  ) {
    updateInterview(input: $input, condition: $condition) {
      id
      treatmentConsultationSeq
      userId
      treatmentSerialNumber
      userInfo
      riskOfSerious
      interview
      travelHistory
      intensiveContact
      statusCode
      createdMonth
      createdAt
      recordTime
      recordConsultation
      recordAssessment
      recordPlan
      covidCertificatePath
      updatedAt
    }
  }
`;
export const deleteInterview = /* GraphQL */ `
  mutation DeleteInterview(
    $input: DeleteInterviewInput!
    $condition: ModelInterviewConditionInput
  ) {
    deleteInterview(input: $input, condition: $condition) {
      id
      treatmentConsultationSeq
      userId
      treatmentSerialNumber
      userInfo
      riskOfSerious
      interview
      travelHistory
      intensiveContact
      statusCode
      createdMonth
      createdAt
      recordTime
      recordConsultation
      recordAssessment
      recordPlan
      covidCertificatePath
      updatedAt
    }
  }
`;
export const createInterview = /* GraphQL */ `
  mutation CreateInterview(
    $input: CreateInterviewInput!
    $condition: ModelInterviewConditionInput
  ) {
    createInterview(input: $input, condition: $condition) {
      id
      treatmentConsultationSeq
      userId
      treatmentSerialNumber
      userInfo
      riskOfSerious
      interview
      travelHistory
      intensiveContact
      statusCode
      createdMonth
      createdAt
      recordTime
      recordConsultation
      recordAssessment
      recordPlan
      covidCertificatePath
      updatedAt
    }
  }
`;
